import _createClass from "/Users/moesalih/Documents/GitHub/moesalih/elliss/elliss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/Users/moesalih/Documents/GitHub/moesalih/elliss/elliss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/Users/moesalih/Documents/GitHub/moesalih/elliss/elliss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/Users/moesalih/Documents/GitHub/moesalih/elliss/elliss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import { IEvents } from "./misc";
export var IJsonRpcConnection = /*#__PURE__*/function (_IEvents) {
  _inherits(IJsonRpcConnection, _IEvents);

  var _super = _createSuper(IJsonRpcConnection);

  function IJsonRpcConnection(opts) {
    _classCallCheck(this, IJsonRpcConnection);

    return _super.call(this);
  }

  return _createClass(IJsonRpcConnection);
}(IEvents);
export var IBaseJsonRpcProvider = /*#__PURE__*/function (_IEvents2) {
  _inherits(IBaseJsonRpcProvider, _IEvents2);

  var _super2 = _createSuper(IBaseJsonRpcProvider);

  function IBaseJsonRpcProvider() {
    _classCallCheck(this, IBaseJsonRpcProvider);

    return _super2.call(this);
  }

  return _createClass(IBaseJsonRpcProvider);
}(IEvents);
export var IJsonRpcProvider = /*#__PURE__*/function (_IBaseJsonRpcProvider) {
  _inherits(IJsonRpcProvider, _IBaseJsonRpcProvider);

  var _super3 = _createSuper(IJsonRpcProvider);

  function IJsonRpcProvider(connection) {
    _classCallCheck(this, IJsonRpcProvider);

    return _super3.call(this);
  }

  return _createClass(IJsonRpcProvider);
}(IBaseJsonRpcProvider);